// extracted by mini-css-extract-plugin
export default {"toggleWrapper":"ButtonToggle_toggleWrapper__1ab7i","active":"ButtonToggle_active__G884l"};